// frontend/src/pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-vh-100 d-flex align-items-center">
      <div className="container text-center">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card shadow-sm">
              <div className="card-body p-5">
                <h1 className="display-1 fw-bold text-primary">404</h1>
                <h2 className="mb-4">ไม่พบหน้าที่คุณต้องการ</h2>
                <p className="text-muted mb-4">
                  หน้าเว็บที่คุณพยายามเข้าถึงไม่มีอยู่หรืออาจถูกย้ายไปแล้ว
                  กรุณาตรวจสอบ URL ที่คุณป้อนหรือกลับไปยังหน้าหลัก
                </p>
                <div className="d-grid gap-2 col-md-6 mx-auto">
                  <Link to="/" className="btn btn-primary">
                    <i className="fas fa-home me-2"></i> กลับสู่หน้าหลัก
                  </Link>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <img
                src="https://person.ssk3.go.th/wp-content/uploads/2023/12/%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B9%80%E0%B8%82%E0%B8%95-3-removebg-preview.png"
                alt="SSK3 Logo"
                style={{ height: '60px' }}
              />
              <div className="mt-2 text-muted">
                <small>
                  &copy; {new Date().getFullYear()} สำนักงานเขตพื้นที่การศึกษาประถมศึกษาศรีสะเกษ เขต 3
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;